export const ROUTE_HOME = `/`;
export const VERSION = `/v1`;
export const ROUTE_BASE_ACCOUNTS = `${VERSION}/accounts`;
export const ROUTE_ACCOUNTS_CARD = `${ROUTE_BASE_ACCOUNTS}/card`;

export const ROUTE_ACCOUNTS_CUSTOM = `${ROUTE_BASE_ACCOUNTS}/custom`;
